import { Box, Tag as DesignSystemTag } from '@factorialco/deprecated-design-system'
import { isNil } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { tagPropsForEmployeeScore } from 'modules/performance_process/lib/employeeScoreColor'

interface Prop {
  score?: number | null
  maxScore?: number
}

const ScoreTag = ({ maxScore, score }: Prop) => {
  if (isNil(score) || isNil(maxScore)) {
    return (
      <Box maxWidth="fit-content">
        <DesignSystemTag type="neutral">
          {i18n.t('performance_process.analytics.datatable.no_data')}
        </DesignSystemTag>
      </Box>
    )
  }

  return (
    <Box maxWidth="fit-content">
      <DesignSystemTag
        leftItem="circle"
        showCircle
        {...tagPropsForEmployeeScore(score, maxScore)}
      >{`${i18n.formatNumber(score)} / ${i18n.formatNumber(maxScore)}`}</DesignSystemTag>
    </Box>
  )
}

export default ScoreTag
